import React from "react";
import ThumbsUp from "../ThumbsUp";
import { FormatUTCDateTime } from "../../../../../utilities/DateFormater";

export default function TestSessions({
  suggestedQuestions,
  handleSubmitPreviousQuestion,
}) {
  console.log("suggestedQuestions", suggestedQuestions);
  return (
    <div className="test-sessions-container">
      <div className="test-session-header">
        <h5>Previous Test Sessions</h5>
      </div>
      <div className="test-session-body-container">
        {suggestedQuestions.length > 0 ? (
          suggestedQuestions.map((suggestedQuestion, index) => {
            return (
              <div
                className="test-session-body-card"
                onClick={() =>
                  handleSubmitPreviousQuestion(suggestedQuestion?.question)
                }>
                <div className="test-session-body-card-info">
                  <p>{FormatUTCDateTime(suggestedQuestion?.timestamp)}</p>
                  {/* <div className="test-session-body-card-info-rating">
                    <p>4.5</p>
                    <ThumbsUp className="thumbs-up-icon" />
                  </div> */}
                </div>
                <p className="test-session-body-card-title">
                  {suggestedQuestion?.question}
                </p>
              </div>
            );
          })
        ) : (
          <p>No previous test sessions</p>
        )}
      </div>
    </div>
  );
}
